import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MachineTasksComponent } from './machine-tasks/machine-tasks.component';
import { Route } from '@angular/router';
import {
  RadioV2Module,
  IconV2Module,
  DateV2Module,
  ModalModule,
  MultiselectV2Module,
  SelectV2Module,
  CheckboxV2Module,
  PagesV2Module,
  SpinnerV2Module,
  TileV2Module,
  WorkflowModule,
  FormsModuleV2,
  ButtonV2Module,
  GridV2Module,
  InputV2Module,
  FileUploadV2Module,
  NotificationsV2Module,
} from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { MachineTaskSettingsApi } from './machine-task-settings.api';
import { MachineTaskSettingsService } from './machine-task-settings.service';
import { MachineTaskSearchService, MachineTaskSearchApi } from './machine-task-search.service';

import { UpsertMachineTaskWizardComponent } from './upsert-machine-task-wizard/upsert-machine-task-wizard.component';
import { ChooseMachineTaskOptionModalComponent } from './choose-machine-task-option-modal/choose-machine-task-option-modal.component';
import { MachineTaskModalComponent } from './task-modal/machine-task-modal.component';
import { FormsModule as AngularFormsModule } from '@angular/forms';
import { machineStepsComponents } from './upsert-machine-task-wizard/steps/index';

export const machineTasksRoutes: Route[] = [{ path: '', component: MachineTasksComponent }];

@NgModule({
  imports: [
    CommonModule,
    AngularFormsModule,
    TranslatePipe,
    TranslateDirective,
    GridV2Module,
    RadioV2Module,
    ButtonV2Module,
    IconV2Module,
    DateV2Module,
    ModalModule,
    MultiselectV2Module,
    SelectV2Module,
    CheckboxV2Module,
    PagesV2Module,
    SpinnerV2Module,
    TileV2Module,
    WorkflowModule,
    FormsModuleV2,
    ButtonV2Module,
    GridV2Module,
    InputV2Module,
    FileUploadV2Module,
    NotificationsV2Module,
    MachineTasksComponent,
    UpsertMachineTaskWizardComponent,
    ChooseMachineTaskOptionModalComponent,
    MachineTaskModalComponent,
    ...machineStepsComponents,
  ],
  providers: [
    MachineTaskSettingsApi,
    MachineTaskSettingsService,
    MachineTaskSearchApi,
    MachineTaskSearchService,
  ],
})
export class MachineTasksModule {}
